import { Box, Grid, TextField, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { validMessage } from '../../../../../constants/ValidsFormConst';
import { dateformat } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import SelectFieldActividadesAcademicasComponent from '../../../../academico/actividades_academicas/components/SelectFieldActividadesAcademicas';
import { FechaField } from '../../../../accesos/components/FechaField';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { savePevaActividadesAction } from '../PevaActividadesAction';

const FormPevaActividades = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const planevaTemasStore = Redux.useSelector((state) => state.planevaTemas);
  const ptemEvaluacionesStore = Redux.useSelector(
    (state) => state.ptemEvaluaciones,
  );
  const pevaActividadesStore = Redux.useSelector(
    (state) => state.pevaActividades,
  );

  const ptemaEvaluacion = ptemEvaluacionesStore.activo;
  const activo = pevaActividadesStore.activo;

  const initData = {
    fecha: planevaTemasStore.activo?.desde,
    ponderacion: '',
    desc: '',
    idInstrumento: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    fecha: false,
    ponderacion: false,
    idInstrumento: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [ponderacionError, setPonderacionError] = React.useState(false);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idInstrumento: activo.instrumento.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSubmit = async () => {
    if (await _validDataForm()) {
      setLoadingSave(true);
      let res = await savePevaActividadesAction(
        { dispatch, notify },
        planEvaluacionStore.activo.id,
        activo?.id,
        {
          ...data,
          ponderacion: parseFloat(data.ponderacion).toFixed(2),
          idPTemaEvaluacion: ptemEvaluacionesStore.activo.id,
        },
        planEvaluacionStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  function getPonderacion() {
    let res = Number(ptemaEvaluacion.ponderacion);

    if (activo) {
      res = res + Number(activo.ponderacion);
    }

    ptemaEvaluacion.instrumentos.forEach((el) => {
      res = res - Number(el.ponderacion ?? '0');
    });
    return res;
  }

  return (
    ptemaEvaluacion && (
      <Box component="form">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
            <Typography variant="body1" color="initial">
              <strong>Evaluación: </strong>
              {ptemaEvaluacion.evaluacion.nombre}
              <br />
              <strong>Ponderación: </strong>
              {ptemaEvaluacion.ponderacion} Pts.
            </Typography>
          </Grid>

          <Grid item xs={12} md={8}>
            <SelectFieldActividadesAcademicasComponent
              id="selectActividades"
              value={data.idInstrumento}
              isEmpty={false}
              required
              onChange={(idInstrumento) => {
                _handleSetDataField(CONST.instrumento.idName, idInstrumento);
              }}
              error={dataError.idInstrumento}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              size="small"
              id={CONST.ponderacion.name}
              required
              label={CONST.ponderacion.label}
              value={data.ponderacion}
              autoComplete="off"
              onChange={(e) => {
                const value = e.target.value;
                if (Number(value) > getPonderacion()) {
                  _handleSetDataField(CONST.ponderacion.name, getPonderacion());
                  return;
                }
                setPonderacionError(false);
                _handleSetDataField(CONST.ponderacion.name, value);
              }}
              helperText={dataError.ponderacion ? validMessage.required : null}
              error={dataError.ponderacion}
              type="number"
              InputProps={{
                inputProps: { min: 1, max: getPonderacion() },
              }}
            />
            {ponderacionError && (
              <Typography variant="body1" color="initial">
                No puede ser mayor a de la evaluación
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={12}>
            <FechaField
              label="Fecha de inicio"
              error={dataError.fecha}
              value={data.fecha}
              botonCurrentDate={false}
              onChange={(e) => {
                const selectedDate = new Date(e);
                const fechaDesdeBloque = new Date(
                  planevaTemasStore.activo.desde,
                );
                const fechaHastaBloque = new Date(
                  planevaTemasStore.activo.hasta,
                );
                setDataRequired({ ...dataError, fecha: false });
                if (selectedDate < fechaDesdeBloque) {
                  notify(
                    'La fecha de inicio no puede ser menor a la fecha actual',
                    { error: true },
                  );
                  _handleSetDataField(
                    CONST.fecha.name,
                    planevaTemasStore.activo.desde,
                  );
                  setDataRequired({ ...dataError, fecha: true });
                  return;
                }
                if (selectedDate > fechaHastaBloque) {
                  notify(
                    'La fecha de inicio no puede ser mayor a la fecha tope del bloque',
                    { error: true },
                  );
                  _handleSetDataField(
                    CONST.fecha.name,
                    planevaTemasStore.activo.desde,
                  );
                  setDataRequired({ ...dataError, fecha: true });
                  return;
                }

                _handleSetDataField(CONST.fecha.name, dateformat(e, {}));
              }}
            />
            <Typography variant="caption" color="initial">
              Rango de fecha consideradas en el tema:{' '}
              {dateformat(planevaTemasStore.activo.desde, { standard: true })}{' '}
              hasta{' '}
              {dateformat(planevaTemasStore.activo.hasta, { standard: true })}
            </Typography>
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              size="small"
              id={CONST.desc.name}
              label={CONST.desc.label}
              value={data.desc}
              multiline
              rows={2}
              onChange={(e) =>
                _handleSetDataField(CONST.desc.name, e.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} md={12} align="center">
            <BotonComponent
              click={_handleSubmit}
              save
              disabled={loadingSave}
              green
            />
          </Grid>
        </Grid>
      </Box>
    )
  );
};

export default FormPevaActividades;
